import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { extractErrorMessage } from "@/lib/errors";
import { getRateLimitDefaults, updateRateLimitDefaults } from "./rateLimit.api";
import type {
  RateLimitDefaults,
  RateLimitDefaultsPayload,
} from "../types/rate-limit.types";

export const RATE_LIMIT_DEFAULTS_KEY = ["rate-limit-defaults"];

export const useGetRateLimitDefaults = () => {
  return useQuery<RateLimitDefaults, Error>({
    queryKey: RATE_LIMIT_DEFAULTS_KEY,
    queryFn: getRateLimitDefaults,
  });
};

export const useUpdateRateLimitDefaults = () => {
  const queryClient = useQueryClient();

  return useMutation<RateLimitDefaults, Error, RateLimitDefaultsPayload>({
    mutationFn: updateRateLimitDefaults,
    onSuccess: (data) => {
      queryClient.setQueryData(RATE_LIMIT_DEFAULTS_KEY, data);
      toast.success("Rate limit defaults updated");
    },
    onError: (err: any) => {
      toast.error("Failed to update rate limits", {
        description: extractErrorMessage(err),
      });
    },
  });
};
